import { render, staticRenderFns } from "./application.vue?vue&type=template&id=47467a4b&"
import script from "./application.vue?vue&type=script&lang=js&"
export * from "./application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports